
































































import { Component, Prop, PropSync } from 'vue-property-decorator';
import Nav from '@/services/Navigation';
import Vue from 'vue';
import HIRT from '@/components/hirt';
import { required } from 'vuelidate/lib/validators';
import { RuleDecl } from 'vue/types/options';

import { convertFromTier, convertToTier, tierOptions } from '@/utils/tiers';

interface Select {
	text: string;
	value: number;
}

@Component({
	components: {
	},
})
export default class NavigationHeader extends Vue implements HIRT {
	@PropSync('nav') localNav!: Nav;
	@Prop({ default: false }) readonly ro!: boolean;

	isMounted = false;
	mounted() {
		this.isMounted = true;
	}

	tierOptions = tierOptions;

	validations(): RuleDecl {
		return {
			localNav: {
				name: { required },
				tier1: { type: {}, display: {} },
				tier2: { type: {}, display: {} },
				tier3: { type: {}, display: {} },
			}
		};
	}

	hasErrors(): boolean {
		return this.$v?.$anyError;
	}

	isDirty(): boolean {
		return this.$v?.$anyDirty;
	}

	reset() {
		this.$v?.$reset();
	}

	touch() {
		this.$v?.$touch();
	}

	get tier1() {
		return convertFromTier(this.localNav.tier1);
	}

	set tier1(newValue) {
		this.localNav.tier1 = convertToTier(newValue.value);
	}

	get tier2() {
		return convertFromTier(this.localNav.tier2);
	}
	
	set tier2(newValue) {
		this.localNav.tier2 = convertToTier(newValue.value);
	}
	get tier3() {
		return convertFromTier(this.localNav.tier3);
	}
	
	set tier3(newValue) {
		this.localNav.tier3 = convertToTier(newValue.value);
	}

	get nameErrorMessage(): string | null{
		return this.isMounted ? (
			(this.$v?.localNav?.name?.$invalid && this.$v?.localNav?.name?.$dirty) ? 'Name is Required' : null
		) : null;
	}

	
}
